/* eslint-disable */
// /src/pages/SignupPage.jsx
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import { signup, isPhoneRegistered } from "../services/authService";
import { useDriverStatusContext } from "context/DriverStatusContext";

// 약관 전문 텍스트
const privacyText = `
개인정보 수집 및 이용 동의(*필수)

1. 수집 및 이용 목적:
본인확인 및 전화·문자메시지 등을 통한 가맹 서비스 관련 안내, 사업자 정보를 위한 개인정보 및 정산정보 취합·운영·관리, 사업자 모집 및 CS 등 업무지원, 일체의 문의사항 및 공지사항 전달, 기타 가맹 서비스 가입과 관련된 사항

2. 개인정보 항목:
성명, 휴대전화번호, 생년월일, 주소, 이메일, 차량 정보, 택시 자격번호(해당 시), 사업자등록정보(사업자일 경우에 한함)

3. 개인정보 수집 및 이용기간:
본인은 본 동의서를 통해 제공된 개인정보가 동의한 날로부터 5년간 보관 및 이용됨을 확인하며, 계약 기간 종료 시 재계약을 체결할 경우 별도의 동의 절차 없이 기존 개인정보 이용 및 보관 기간의 재연장에 동의합니다. 개인정보 보호법 등 관계 법령에 따라 정보주체는 언제든지 개인정보 처리에 대한 동의를 철회할 수 있으며, 계약 기간 종료 시 또는 정보주체의 동의 철회 시 관계 법령에 따라 즉시 파기됩니다.

※ 상기 본인은 「개인정보 보호법」 제15조(개인정보의 수집·이용) 및 동법 제22조(동의를 받는 방법)에 의거하여 DH모빌리티가 가맹서비스를 목적으로 개인정보를 수집·이용 및 처리함에 동의합니다.
※ 본 동의는 가맹 서비스 제공 및 정산, 고객 응대, 공지사항 안내 목적에 필수적으로 필요하며, 동의 거부 시 가맹 서비스 신청이 제한될 수 있습니다.
`;

const marketingText = `
📌 광고‧마케팅 수신 동의서(*선택)

[광고‧마케팅 정보 수신 동의 선택]
헤이웨이(Hey’Way)는 회원님께 더 나은 서비스 제공을 위해 아래와 같은 광고 및 마케팅 정보를 전달할 수 있습니다. 동의를 거부하실 수 있으며, 거부하더라도 서비스 이용에는 제한이 없습니다.

■ 전송 목적
- 신규 서비스 및 이벤트 안내
- 프로모션·쿠폰·혜택 정보 제공
- 제휴사(운수사·가맹본부·광고파트너) 관련 혜택 안내
- 앱 공지, 맞춤형 광고 및 리워드 제공

■ 전송 항목
이름, 휴대전화번호, 카카오톡 ID, 앱 푸시 토큰, 이메일 주소

■ 전송 방법
앱 푸시 알림, 카카오 알림톡, 문자(SMS/MMS), 이메일 등

■ 보유 및 이용 기간
동의 철회 시까지 (단, 관련 법령에 따라 필요한 경우 별도 보관)

■ 동의 철회 안내
앱 내정보 경로를 통해 언제든지 광고성 정보 수신 동의를 철회할 수 있습니다.
`;

export default function SignupPage() {
  const nav = useNavigate();
  const loc = useLocation();
  const phoneE164 = useMemo(() => loc?.state?.phoneE164 || "", [loc]);
  const verified = !!loc?.state?.verified;

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [carNumber, setCarNumber] = useState("");
  const [memberType, setMemberType] = useState(""); // "personal" | "corporate" | "general"
  const [agreePrivacy, setAgreePrivacy] = useState(false);     // 개인정보동의(필수)
  const [agreeMarketing, setAgreeMarketing] = useState(false); // 광고동의(선택)
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showMarketing, setShowMarketing] = useState(false);

  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [blocked, setBlocked] = useState(false);

  const { refresh } = useDriverStatusContext(); // ✅ 추가

  // ✅ 진입 시 해당 번호가 이미 가입된 상태면 차단 (Firestore 비동기 버전)
  useEffect(() => {
    if (!phoneE164) return;
    let cancelled = false;

    (async () => {
      try {
        const exists = await isPhoneRegistered(phoneE164);
        if (!cancelled && exists) {
          setErr("이미 가입된 회원입니다. 로그인으로 이동해주세요.");
          setBlocked(true);
        }
      } catch (e) {
        console.error("[SignupPage] isPhoneRegistered error", e);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [phoneE164]);

  const handleBack = () => {
    nav(-1);
  };

  const requiresCarNumber =
    memberType === "personal" || memberType === "corporate";

  // 🔹 dhm.session 저장 유틸
  const saveSession = () => {
    if (typeof window === "undefined") return;
    try {
      const session = {
        auth: "member",
        username,
        phoneE164,
        name,
        memberType,
      };
      window.localStorage.setItem("dhm.session", JSON.stringify(session));
      console.log("[SignupPage] dhm.session saved", session);
    } catch (e) {
      console.error("[SignupPage] failed to save dhm.session", e);
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!verified || !phoneE164 || blocked || loading) return;

    if (!memberType) {
      setErr("회원 유형을 선택해 주세요.");
      return;
    }
    if (requiresCarNumber && !carNumber.trim()) {
      setErr("택시 기사 회원은 차량번호를 입력해 주세요.");
      return;
    }
    if (!agreePrivacy) {
      setErr("개인정보동의에 체크해 주세요.");
      return;
    }

    setErr("");
    try {
      setLoading(true);
      await signup({
        username,
        password,
        name,
        phoneE164,
        carNumber: carNumber.trim(), // 일반회원이면 빈 값 허용
        memberType,
        agreePrivacy,
        agreeMarketing,
      });

      // ✅ 회원가입 성공 시 세션 저장
      saveSession();

      try {
        refresh();
      } catch (eRefresh) {
        console.warn("[LoginPage] driverStatus refresh failed", eRefresh);
      }


      nav("/home", { replace: true });
    } catch (e2) {
      setErr(e2?.message || "가입에 실패했습니다. 입력값을 확인해주세요.");
    } finally {
      setLoading(false);
    }
  };

  const disabledSubmit =
    !verified ||
    !phoneE164 ||
    blocked ||
    loading ||
    !username ||
    !password ||
    !name ||
    !memberType ||
    (requiresCarNumber && !carNumber.trim()) ||
    !agreePrivacy; // 개인정보동의 필수

  return (
    <Wrap>
      <Card as="form" onSubmit={onSubmit}>
        <HeaderRow>
          <BackButton type="button" onClick={handleBack}>
            <span className="arrow">←</span>
            <span className="label">뒤로</span>
          </BackButton>
        </HeaderRow>

        <Title>회원가입</Title>

        <Field>
          <label>휴대폰</label>
          <Readonly>{phoneE164 || "(인증 필요)"}</Readonly>
        </Field>

        {blocked && (
          <BlockedBox>
            이미 가입된 회원입니다. <a href="/login">로그인 화면으로 이동</a>
          </BlockedBox>
        )}

        <Field>
          <label>아이디</label>
          <input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="아이디"
            autoFocus
            disabled={blocked}
          />
        </Field>

        <Field>
          <label>비밀번호</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="비밀번호"
            disabled={blocked}
          />
        </Field>

        <Field>
          <label>이름</label>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="홍길동"
            disabled={blocked}
          />
        </Field>

        <Field>
          <label>
            차량번호
          </label>
          <input
            value={carNumber}
            onChange={(e) => setCarNumber(e.target.value)}
            placeholder={"예: 12가3456 "}
            disabled={blocked}
          />
        </Field>

        {/* 🔹 회원 유형 선택 */}
        <Field>
          <label>회원 유형</label>
          <RoleGroup>
            <RoleOption
              type="button"
              $active={memberType === "personal"}
              onClick={() => setMemberType("personal")}
              disabled={blocked}
            >
              <span className="icon">🚕</span>
              <span className="label">개인택시 기사</span>
            </RoleOption>
            <RoleOption
              type="button"
              $active={memberType === "corporate"}
              onClick={() => setMemberType("corporate")}
              disabled={blocked}
            >
              <span className="icon">🧾</span>
              <span className="label">법인택시 소속 기사</span>
            </RoleOption>
            <RoleOption
              type="button"
              $active={memberType === "general"}
              onClick={() => setMemberType("general")}
              disabled={blocked}
            >
              <span className="icon">👤</span>
              <span className="label">일반 회원 (택시 기사 아님)</span>
            </RoleOption>
          </RoleGroup>
        </Field>

        {/* 🔹 약관 동의 */}
        <AgreeSection>
          <AgreeRow>
            <input
              type="checkbox"
              checked={agreePrivacy}
              onChange={() => setAgreePrivacy(!agreePrivacy)}
            />
            <span>개인정보동의</span>
            <ViewBtn type="button" onClick={() => setShowPrivacy(true)}>
              보기
            </ViewBtn>
          </AgreeRow>

          <AgreeRow>
            <input
              type="checkbox"
              checked={agreeMarketing}
              onChange={() => setAgreeMarketing(!agreeMarketing)}
            />
            <span>광고동의</span>
            <ViewBtn type="button" onClick={() => setShowMarketing(true)}>
              보기
            </ViewBtn>
          </AgreeRow>
        </AgreeSection>

        {err && <ErrorMsg>{err}</ErrorMsg>}

        <Button type="submit" disabled={disabledSubmit}>
          가입
        </Button>

        <Hint>
          이미 계정이 있으신가요? <a href="/login">로그인</a>
        </Hint>
      </Card>

      {/* 개인정보동의 전문 모달 */}
      {showPrivacy && (
        <Dim onClick={() => setShowPrivacy(false)}>
          <Modal onClick={(e) => e.stopPropagation()}>
            <ModalTitle>개인정보 수집 및 이용 동의</ModalTitle>
            <ModalBody>{privacyText}</ModalBody>
            <CloseBtn type="button" onClick={() => setShowPrivacy(false)}>
              닫기
            </CloseBtn>
          </Modal>
        </Dim>
      )}

      {/* 광고동의 전문 모달 */}
      {showMarketing && (
        <Dim onClick={() => setShowMarketing(false)}>
          <Modal onClick={(e) => e.stopPropagation()}>
            <ModalTitle>광고‧마케팅 정보 수신 동의</ModalTitle>
            <ModalBody>{marketingText}</ModalBody>
            <CloseBtn type="button" onClick={() => setShowMarketing(false)}>
              닫기
            </CloseBtn>
          </Modal>
        </Dim>
      )}
    </Wrap>
  );
}

/* ===== 스타일 ===== */

const Wrap = styled.div`
  min-height: 100dvh;
  display: grid;
  place-items: center;
  background: #fff;
`;

const Card = styled.div`
  width: min(520px, 92vw);
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 16px;
  padding: 20px 20px 24px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid #e0e0e0;
  background: #fafafa;
  font-size: 13px;
  cursor: pointer;

  .arrow {
    font-size: 14px;
  }

  .label {
    line-height: 1;
  }
`;

const Title = styled.h2`
  margin: 0 0 16px;
  font-size: 22px;
`;

const Field = styled.div`
  display: grid;
  gap: 6px;
  margin-bottom: 14px;

  label {
    font-size: 13px;
    color: #666;
  }

  input {
    height: 46px;
    border-radius: 12px;
    border: 1px solid #ddd;
    padding: 0 12px;
    font-size: 15px;
  }
`;

const Readonly = styled.div`
  height: 46px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  border-radius: 12px;
  background: #f8f8f8;
  border: 1px solid #eee;
  color: #333;
`;

const ErrorMsg = styled.div`
  color: #c00;
  font-size: 13px;
  margin: 6px 0 4px;
`;

const Button = styled.button`
  width: 100%;
  height: 50px;
  border-radius: 12px;
  font-weight: 800;
  font-size: 16px;
  color: #fff;
  background: #3479d6;
  border: none;
  margin-top: 18px;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const Hint = styled.p`
  margin: 14px 0 0;
  font-size: 13px;
  color: #666;

  a {
    color: #3479d6;
  }
`;

const BlockedBox = styled.div`
  padding: 10px 12px;
  border-radius: 10px;
  background: #fff5f5;
  border: 1px solid #ffd5d5;
  color: #a00;
  font-size: 13px;
  margin: 4px 0 10px;
`;

/* ===== 회원 유형 선택 스타일 ===== */

const RoleGroup = styled.div`
  display: grid;
  gap: 8px;
`;

const RoleOption = styled.button`
  width: 100%;
  border-radius: 12px;
  border: 1px solid ${({ $active }) => ($active ? "#3479d6" : "#ddd")};
  background: ${({ $active }) => ($active ? "#e5efff" : "#fff")};
  padding: 10px 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: left;
  cursor: pointer;
  font-size: 14px;

  .icon {
    font-size: 18px;
  }

  .label {
    flex: 1;
  }
`;

/* ===== 동의 영역 스타일 ===== */

const AgreeSection = styled.div`
  margin-top: 18px;
  display: grid;
  gap: 10px;
`;

const AgreeRow = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;

  input {
    width: 16px;
    height: 16px;
  }

  span {
    color: #111827;
  }
`;

const ViewBtn = styled.button`
  margin-left: auto;
  border: none;
  background: #e5e7eb;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
`;

/* ===== 약관 모달 스타일 ===== */

const Dim = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 9000;
`;

const Modal = styled.div`
  width: min(520px, 92vw);
  max-height: 80vh;
  overflow-y: auto;
  background: #fff;
  border-radius: 16px;
  padding: 18px 20px;
`;

const ModalTitle = styled.h3`
  margin: 0 0 12px;
  font-size: 17px;
  font-weight: 800;
`;

const ModalBody = styled.pre`
  white-space: pre-wrap;
  font-size: 13px;
  color: #333;
  line-height: 1.45;
  margin-bottom: 18px;
`;

const CloseBtn = styled.button`
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 10px;
  background: #1f2937;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
`;
